/**
 * 事件总线实例（基于mitt实现）
 * 使用说明：
 * 1. 发射事件：eventBus.emit('eventName', data)
 * 2. 监听事件：eventBus.on('eventName', callback)
 * 3. 移除监听：eventBus.off('eventName', callback)
 */
import mitt from 'mitt'

// 创建事件总线实例
const eventBus = mitt()

export default eventBus